<template>
  <div style="display: inline-block">
    <el-button-group>
      <el-button size="small" type="primary" icon="el-icon-arrow-left" @click="prevMonth">上一年</el-button>
      <el-button size="small" type="primary" @click="chooseYear">{{ searchCondition.year }}年
      </el-button>
      <el-button size="small" type="primary" @click="nextMonth">下一年<i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
    </el-button-group>
    <!--    月份选择-->
    <el-popover
        placement="bottom"
        title=""
        width="250"
        trigger="manual"
        v-model="visible">
      <div style="text-align: center">
        <el-date-picker style="width: 80%"
                        :clearable="true" v-model="searchCondition.year"
                        value-format="yyyy"
                        format="yyyy年"
                        type="year"
                        placeholder="选择月份" @change="setYear"/>
      </div>
      <!--      <el-button slot="reference" @click="visible = !visible">手动激活</el-button>-->
    </el-popover>
  </div>
</template>

<script>
export default {
  name: "YearSelectGroup",
  props: {
    autoSelected: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      searchCondition: { year: null },
      visible: false
    }
  },
  methods: {
    chooseYear() {
      // this.$notify.success('选择月份')
      this.visible = !this.visible
      if (this.visible) {
        this.ym = this.searchCondition.year + ''
      }
    },
    setYear() {
      this.visible = false
      this.$emit('selected', this.searchCondition)
    },
    changeYear(type) {
      let year = this.searchCondition.year
      // let month = this.searchCondition.month

      const start = new Date(year, 0, 1);
      if (type === 'prev') {
        start.setFullYear(start.getFullYear() - 1);
      } else {
        start.setFullYear(start.getFullYear() + 1);
      }
      this.searchCondition.year = start.getFullYear() + ''
      // this.searchCondition.month = start.getMonth() + 1
      this.$emit('selected', this.searchCondition)
    },
    prevMonth() {
      this.changeYear('prev')
    },
    nextMonth() {
      this.changeYear('next')
    },
    getLastDays(days) {
      //几天前的时间
      let day1 = new Date();
      day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000 * days);
      return day1.getFullYear() + "-" + (day1.getMonth() + 1) + "-" + day1.getDate();
    },
    defaultMonth() {
      let date = new Date();
      this.searchCondition.year = date.getFullYear() + ''
      // this.searchCondition.month = date.getMonth() + 1
      if (this.autoSelected)
        this.$emit('selected', this.searchCondition)
    }
  },
  mounted() {
    //默认年月
    this.defaultMonth()
  }
}
</script>

<style scoped>

</style>
